import packageInfo from '../../package.json';
export const environment = {
	production: true,
	watchOnly: false,
	env: 'UAT_ALDAR',
	matchMakerUrl: 'https://api-uat.aldar.com',
	baseUrl: 'https://api-uat.aldar.com',
	authorityUrl: 'https://login.microsoftonline.com/ab98858a-ce1a-4fea-a19b-e31ea792a488',
	azureClientId: '0bfc818f-ed3a-4a55-9094-64ed3e69442b',
	authWellknownEndpointUrl: 'https://login.microsoftonline.com/common/v2.0',
	version: packageInfo.version,
	microStrategyUrl: 'https://mstr-uat.aldar.com/MicroStrategyLibrary',
	microStrategyProjectId: 'CDCD73B2A3406F62C8DBD481455CABB5',
	microStrategyDossierGatewaySummary: '9B5EF38443432050CC717E9853B77E85',
	microStrategyDossierLBMFeasibilityTool: '27EAF7949E4906BBA06BC2A4796A2535',
	microStrategyDossierLBMFeasibilityToolFinancialModel: '43DD53C18A49334141772E95E58F67F7',
	microStrategyDossierDesignLifecycle: 'BD76E77FA1411C2DD16624BB4E5DC3E8',
	microStrategyDossierLBMSectorReport: '0053267B7A440405D0B673A91F50935A',
	microStrategyDossierLandBankSummary: 'D375FEF0E247A77878D61AA3AC8F2464',
	microStrategyDossierDevelopmentSummary: 'A8989EF36649A32AE5E386B2CC089979',
	microStrategyDossierPlotsSalesSummary: 'F9DA5C293543DADCB7EC3BA8278C319A',
	microStrategyDossierSalesSummary: '2338408C5A499E8C0F10B381C5DDAC58',
	microStrategyDossierPlotSummary: '36EE99AEFD4AA9F8E2DE238A17C3837F',
	microStrategyDossierBuildingSummary: '6A22C1AC5E4A89EEAF2CC4AD088744E5',
	microStrategyDossierSummaryViewId: 'E4A06416034B063715E661AFF90EA8C0',
	microStrategyDossierDashboardBuildings: 'FD1DBCA2444D0A2C92B238B92AF39244',
	microStrategyDossierDashboardSnDResidential: 'E124B9C721478874680093BE0A7B2621',
	microStrategyDossierDashboardSnDOffice: '081908802049DCAE091DC395A7A6F4EF',
	microStrategyDossierDashboardSnDRetail: '07A65F2D394CB7C98E2E4EA3F5ADB73B',
	microStrategyDossierDashboardSnDHospitality: '67803AF1854164AE67343F973C31C0DD',
	microStrategyDossierDashboardRent: '9D02CE6E7F415B0F73E7BE980E13CD8D',
	microStrategyDossierDashboardSale: 'F92CE276CA40CFB33C1396A688BD1FB9',
	microStrategyDossierSummaryViewIdREI: '03B98F09C94F70369F9B4E854C29859E',
	microStrategyDossierSummaryViewIdREIBuildings: 'CE731FD3224EED7563BCA68A31F7A9F6',
	microStrategyDossierSummaryViewIdREISnD: '18505A8A1C4E07D1BA2143B7BD7A09DF',
	microStrategyDossierSummaryViewIdREIRent: 'C4A0ACCFAE4D091676CF41AF239CB6E9',
	microStrategyDossierSummaryViewIdREISale: 'E463D3F9A644543149B9E0B54D90FCCC',
	microStrategyDossierDashboardDevTools: '8A6B27D0C5447FA06D70CABC53612B28',
	envId: 'd575ad35-acd0-4517-984b-96ea7499a054',
	accessControl: 'https://api-uat.aldar.com',
	cmsToken: '7078def0b2bc4a179f1f7968ee467afb',
	sessionExpiration: 86400,
	apiServiceTimeout: 30,
	instrumentationKey: '99325a54-bcd7-4b37-8970-3d14c6470c2f',
	dataDogApplicationId: 'd48b76e7-b511-4060-9a00-8d575385f7f3',
	dataDogClientToken: 'pube253049ec1bf606dc9c8f346d5b23d58',
	gatewayUrl: 'https://aldaruae.sharepoint.com/sites/GatewaysSTG',
	datadogIP: 'http://172.17.11.63',
	datadogService: 'web-digitalharbour-uat',
	datadogEnv: 'uat',
	StreamPixelURL: 'https://stream.streampixel.io/683717e22e6444cdd59ee135',
	embedGateWayUrl: 'https://apps.powerapps.com/play/e/55858ecc-7c70-e6fc-869f-fd19a7ad0e40/a/36cd6afc-9475-4582-ab2a-6d363f5363da?harbour=true',
	urlFahidIsland: "https://terra.soluis.com/",
    urlSadiyatIsland: "https://scd.soluis.com/",
	digitalCoreUrl: 'https://app-nxc-dcr-dev-un-001.azurewebsites.net',
	buildingXUrl: 'https://energymanager.siemens.com/#/main/site-details/consumption-flow'
};
